/**
 * Transactions is the only payable home. Old /procurement list URLs land here
 * with ledger filters preserved (Budget Materials Order uses ?projectId=).
 * Invoice detail stays on /procurement/invoices/details?id= — do not rebuild it.
 */

export const TRANSACTIONS_HOME = '/financial/transactions';

const LEDGER_KEYS = [
  'projectId',
  'locationId',
  'supplierId',
  'status',
  'type',
  'linked',
  'q',
  'dateFrom',
  'dateTo',
  'sort',
  'dir',
  'page',
] as const;

export function transactionsHomeHref(
  search?: string | URLSearchParams | null,
): string {
  const params =
    search instanceof URLSearchParams
      ? search
      : new URLSearchParams((search ?? '').replace(/^\?/, ''));

  const next = new URLSearchParams();
  for (const key of LEDGER_KEYS) {
    const value = params.get(key);
    if (value && value !== 'all') next.set(key, value);
  }
  // Procurement list used `search`; Transactions reads `q`.
  if (!next.get('q')) {
    const legacySearch = params.get('search');
    if (legacySearch) next.set('q', legacySearch);
  }
  const qs = next.toString();
  return qs ? `${TRANSACTIONS_HOME}?${qs}` : TRANSACTIONS_HOME;
}
